import script from "./BirthDateView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BirthDateView.vue?vue&type=script&lang=ts&setup=true"

import "./BirthDateView.vue?vue&type=style&index=0&id=ba9f4ec8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba9f4ec8"]])

export default __exports__